const accessories = [
    {
        name: "Костровые ямы",
        img: "./images/category/костровые ямы.png"
        
        
    },
    {
        name: "Лампы & фонари",
        img: "./images/category/лампы & фонари.png"
    },

    { 
      name: "Половики", 
      img: "./images/category/половики.png"
    },
    { 
      name: "Горшки", 
      img: "./images/category/горшки.png"
    },
    
];

export default accessories;
